import api from "src/api/axios";

const createReport = async (input) => {
  return api.post(`/reports`, input).then((result) => {
    return result.data;
  });
};

const createBulkReport = async (input) => {
  return api.post(`/reports/bulk-create`, input).then((result) => {
    return result.data;
  });
};

const updateReport = async (input, id) => {
  return api.patch(`/reports/${id}`, input).then((result) => {
    return result.data;
  });
};

const updateReportStatus = async (input, id) => {
  return api.patch(`/reports/change-status/${id}`, input).then((result) => {
    return result.data;
  });
};

const getReportList = async (urlParams) => {
  const params = new URLSearchParams();

  for (const key in urlParams) {
    if (urlParams.hasOwnProperty(key)) {
      const value = urlParams[key];
      // Check if the value is not null or undefined or not empty string
      if (value) {
        if (key === "sort" && Array.isArray(value)) {
          // If it's the sort parameter and it's an array, join it
          params.append(key, value.join(","));
        } else {
          params.append(key, value);
        }
      }
    }
  }
  // console.log(params);
  return api.get(`/reports?${params}`).then((result) => {
    return result.data;
  });
};

const getSingleReport = async (id) => {
  return api.get(`/reports/${id}`).then((result) => {
    return result.data;
  });
};

const getReportLogs = (id) =>
  api.get(`/reports/${id}/logs`).then((res) => res.data);

export {
  createReport,
  getReportList,
  getSingleReport,
  updateReport,
  updateReportStatus,
  createBulkReport,
  getReportLogs,
};
